export function objectIsEqual(obj1: object, obj2: object) {
  if (!obj1 || !obj2) return false;

  const unequal = Object.keys(obj1).find((key) => {
    return obj1[key] !== obj2[key];
  });

  const unequalNew = Object.keys(obj2).find((key) => {
    return obj1[key] !== obj2[key];
  });

  return unequal || unequalNew ? false : true;
}

export function dataIsValid(formValidation, setFormValidation, formData) {
  const clone = { ...formValidation };
  let valid = true;
  Object.keys(formValidation).forEach((key) => {
    if (formValidation[key].required && !formData[key]) {
      formValidation[key].error = true;
      valid = false;
    } else {
      formValidation[key].error = false;
    }
  });

  setFormValidation(clone);
  return valid;
}
